import * as programPointConsts from "./constants";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
import { makeCall, handleProgramServiceError } from "@/utils/request";
import transform from "./transform";
import { buildOptions, getEndPoints } from "@/utils/api-call";

export const state = {
  programCategories: [],
  programSubCategories: []
};

export const getters = {
  [programPointConsts.GETTERS_PROGRAM_CATEGORIES_POINT]: state => {
    return state.programCategories;
  },
  [programPointConsts.GETTERS_PROGRAM_SUB_CATEGORIES]: state => {
    return state.programSubCategories;
  }
};

export const actions = {
  [programPointConsts.ACTION_GET_PROGRAM_CATEGORIES_LIST]: (
    { commit },
    options
  ) => {
    const url = getEndPoints().program_categories.getList;
    makeCall(url, buildOptions("GET", {}), commit)
      .then(response => {
        if (response.data) {
          let transformList = transform.convertListCategoryModel(response.data);
          commit(
            programPointConsts.MUTATION_SET_PROGRAM_CATEGORIES_POINT,
            transformList
          );
        }
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [programPointConsts.ACTION_GET_SUB_PROGRAM_CATEGORIES]: (
    { commit },
    options
  ) => {
    const url =
      getEndPoints().program_sub_categories.getList + options.CategoryCode;
    makeCall(url, buildOptions("GET", {}), commit)
      .then(response => {
        if (response) {
          let transformList = transform.convertListSubCategoryModel(response);
          commit(
            programPointConsts.MUTATION_SET_SUB_PROGRAM_CATEGORIES,
            transformList
          );
        }
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [programPointConsts.ACTION_SET_PROGRAM_CATEGORIES_LIST]: (
    { commit },
    list
  ) => {
    commit(
      programPointConsts.MUTATION_SET_PROGRAM_CATEGORIES_POINT,
      transform.convertListPointModel(list)
    );
  },
  [programPointConsts.ACTION_ADD_PROGRAM_CATEGORY_POINTS]: (
    { commit },
    options
  ) => {
    let rawData = transform.convertPointRawModel(options.data);
    options.data = rawData;
    const url = getEndPoints().program_categories.add;
    makeCall(url, buildOptions("POST", options.data), commit)
      .then(response => {
        if (response) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        }
        if (options.callback) {
          options.callback(transform.convertPointModel(response));
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [programPointConsts.ACTION_EDIT_PROGRAM_CATEGORY_POINTS]: (
    { commit },
    options
  ) => {
    let rawData = transform.convertPointRawModel(options.data);
    options.data = rawData;
    const url = getEndPoints().program_categories.edit.replace(
      ":id",
      options.id
    );
    makeCall(url, buildOptions("PATCH", options.data), commit)
      .then(response => {
        if (response) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        }
        if (options.callback) {
          options.callback(transform.convertPointModel(response));
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [programPointConsts.ACTION_EDIT_LIST_PROGRAM_CATEGORY_POINTS]: (
    { commit },
    options
  ) => {
    const url = getEndPoints().program_categories.editList.replace(
      ":id",
      options.programId
    );
    makeCall(url, buildOptions("POST", options.data), commit)
      .then(response => {
        if (response) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        }
        if (options.callback) {
          options.callback(transform.convertListPointModel(response));
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [programPointConsts.ACTION_EDIT_LIST_PROGRAM_SUBCATEGORY_POINTS]: (
    { commit },
    options
  ) => {
    const url = getEndPoints().program_sub_categories.editList.replace(
      ":id",
      options.id
    );
    makeCall(url, buildOptions("POST", options.data), commit)
      .then(response => {
        if (response) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        }
        if (options.callback) {
          options.callback(transform.convertListSubPointModel(response));
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [programPointConsts.ACTION_EDIT_PROGRAM_LIST_CATEGORY_POINTS]: (
    { commit },
    options
  ) => {
    let rawData = transform.convertListPointRawModel(options.data);
    const url = getEndPoints().program_categories.saveList.replace(
      ":id",
      options.id
    );
    return makeCall(url, buildOptions("POST", rawData), commit)
      .then(response => {
        if (response) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        }
        if (options.callback) {
          options.callback(transform.convertListPointModel(response));
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [programPointConsts.ACTION_DELETE_PROGRAM_CATEGORY_POINTS]: (
    { commit },
    options
  ) => {
    const url = getEndPoints().program_categories.edit.replace(
      ":id",
      options.id
    );
    return makeCall(url, buildOptions("DELETE", {}), commit)
      .then(response => {
        if (response) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        }
        if (options.callback) {
          options.callback();
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [programPointConsts.ACTION_ADD_PROGRAM_SUB_CATEGORY_POINTS]: (
    { commit },
    options
  ) => {
    let rawData = transform.convertSubPointRawModel(options.data);
    options.data = rawData;
    const url = getEndPoints().program_sub_categories.add;
    makeCall(url, buildOptions("POST", options.data), commit)
      .then(response => {
        if (response) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        }
        if (options.callback) {
          options.callback(transform.convertSubPointModel(response));
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [programPointConsts.ACTION_EDIT_PROGRAM_SUB_CATEGORY_POINTS]: (
    { commit },
    options
  ) => {
    let rawData = transform.convertSubPointRawModel(options.data);
    options.data = rawData;
    const url = getEndPoints().program_sub_categories.edit.replace(
      ":id",
      options.id
    );
    makeCall(url, buildOptions("PATCH", options.data), commit).then(
      response => {
        if (response) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        }
        if (options.callback) {
          options.callback(transform.convertPointModel(response));
        }
      }
    );
  },
  [programPointConsts.ACTION_DELETE_PROGRAM_SUB_CATEGORY_POINTS]: (
    { commit },
    options
  ) => {
    const url = getEndPoints().program_sub_categories.edit.replace(
      ":id",
      options.id
    );
    makeCall(url, buildOptions("DELETE", {}), commit)
      .then(() => {
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        if (options.callback) {
          options.callback(options.item);
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  }
};

export const mutations = {
  [programPointConsts.MUTATION_SET_PROGRAM_CATEGORIES_POINT]: (state, data) => {
    state.programCategories = data;
  },
  [programPointConsts.MUTATION_SET_SUB_PROGRAM_CATEGORIES]: (state, data) => {
    state.programSubCategories = data;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_points/index.js